module.exports = __webpack_public_path__ + "img/virtual_tour.6a9791d0.jpg";